export enum IntradayCash {
  Initial = 'Initial',
  ShopList = 'ShopList'
}
